export const bulletinSettingsInitialState = {
  headerConfig: {
    isHeaderActive: false,
    isDateActive: false,
    title: null,
    subtitle: null,
    logo: {
      image: null,
      localName: null,
      serverName: null,
    },
  },
  sortedPlatforms: [
    'news',
    'instagram',
    'instagramStories',
    'instagramComment',
    'twitter',
    'virasty',
    'telegram',
    'newspaper',
    'nativePlatforms',
    'linkedin',
  ],
  generalConfigs: {
    directory: {
      isActive: false,
      options: {
        includeFirstPage: false,
        includeLastPage: true,
      },
    },
    newsDescription: {
      isActive: false,
    },
    autoArchive: {
      isActive: false,
      options: {
        archiveAfterTwentyFourHours: false,
        archiveAfterOneWeek: true,
        archiveAfterOneMonths: false,
      },
    },
    pageNumber: {
      isActive: false,
    },
    tableOfContents: {
      isActive: false,
    },
    republishers: {
      isActive: true,
    },
    shortLink: {
      isActive: true,
    },
    validateImagesStatus: {
      isActive: true,
    },
  },
  highlightWords: [],
  firstPageConfigs: {
    titles: {
      firstTitle: {
        customName: null,
        titleSize: 40,
        titleColor: '#1d2333',
        options: {
          noName: false,
          useBulletinName: true,
          useCustomName: false,
          useTodayDate: false,
        },
      },
      secondTitle: {
        customName: null,
        titleSize: 25,
        titleColor: '#1d2333',
        options: {
          noName: false,
          useBulletinName: false,
          useCustomName: false,
          useTodayDate: true,
        },
      },
      thirdTitle: {
        customName: null,
        titleSize: 20,
        titleColor: '#1d2333',
        options: {
          noName: true,
          useBulletinName: false,
          useCustomName: false,
          useTodayDate: false,
        },
      },
    },
    logo: {
      image: null,
      localName: null,
      serverName: null,
    },
    cover: {
      selectedCoverImageName: null,
      customCover: {
        image: null,
        serverName: null,
      },
    },
  },
  prevState: {},
  updateRequest: {
    loading: false,
    error: null,
  },
  fetchRequest: {
    loading: false,
    error: null,
  },
  uploadImage: {
    loading: false,
    error: null,
  },
};
